module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO44IngresosMayoresQueGastos.631aef1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO44IngresosMayoresQueGastos.mp4
// module id = 770
// module chunks = 1